export const makeErrorWithCode = (key, getMessage) => class extends Error {
    constructor(...args) {
        super(getMessage(...args));
    }
    get name() {
        return `${super.name} [${key}]`;
    }
    get code() {
        return key;
    }
};

//# sourceMappingURL=makeErrorWithCode.js.map
